import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserRank } from './components/UserRank';
import { KidsPerformanceSection } from './components/KidsPerformanceSection';
import { BottomNav } from './components/BottomNav';
import ReactPlayer from 'react-player';
import { PlayCircleIcon, HelpCircleIcon, BellIcon } from 'lucide-react';
export function App() {
  const navigate = useNavigate();
  const [playingVideo, setPlayingVideo] = useState<string | null>(null);
  const [completedGames, setCompletedGames] = useState(0);
  useEffect(() => {
    // 从localStorage读取游戏完成数
    const savedGames = parseInt(localStorage.getItem('completedGames') || '0');
    setCompletedGames(savedGames);
    // 监听storage变化(如果需要实时更新)
    const handleStorageChange = () => {
      const updatedGames = parseInt(localStorage.getItem('completedGames') || '0');
      setCompletedGames(updatedGames);
    };
    window.addEventListener('storage', handleStorageChange);
    // 使用自定义事件来监听同一页面内的localStorage变化
    const handleCustomStorageChange = () => {
      const updatedGames = parseInt(localStorage.getItem('completedGames') || '0');
      setCompletedGames(updatedGames);
    };
    window.addEventListener('localStorageUpdate', handleCustomStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('localStorageUpdate', handleCustomStorageChange);
    };
  }, []);
  const currentUser = {
    id: 'user-123',
    name: '妈妈，张春燕',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
    points: 720,
    completedLessons: 23,
    streak: 15,
    completedGames: completedGames
  };
  const todayCourse = {
    videos: [{
      id: 'today-v1',
      title: '0-6个月宝宝发展指南',
      duration: '2:49',
      url: 'https://www.youtube.com/watch?v=kc7nN-r5y2I',
      quizzes: [{
        id: 'tq1-1',
        question: '低月龄宝宝胀气是否是哭闹的原因之一?',
        options: ['是', '否', '不确定']
      }, {
        id: 'tq1-2',
        question: '宝宝每天需要多少小时的睡眠?',
        options: ['12-14小时', '14-17小时', '18-20小时']
      }]
    }, {
      id: 'today-v2',
      title: '半岁宝宝发展',
      duration: '4:32',
      url: 'https://www.youtube.com/watch?v=4otE7HxWKJg',
      quizzes: [{
        id: 'tq2-1',
        question: '6个月宝宝可以开始添加辅食了吗?',
        options: ['可以', '不可以', '需要医生建议']
      }, {
        id: 'tq2-2',
        question: '宝宝翻身是正常的发展里程碑吗?',
        options: ['是', '否', '因人而异']
      }]
    }, {
      id: 'today-v3',
      title: '一岁宝宝发展',
      duration: '4:45',
      url: 'https://www.youtube.com/watch?v=kc7nN-r5y2I',
      quizzes: [{
        id: 'tq3-1',
        question: '1岁宝宝应该会说几个词?',
        options: ['1-3个', '5-10个', '10个以上']
      }, {
        id: 'tq3-2',
        question: '宝宝开始走路是在什么时候?',
        options: ['9-12个月', '12-15个月', '15-18个月']
      }]
    }, {
      id: 'today-v4',
      title: '宝宝语言发展',
      duration: '5:20',
      url: 'https://www.youtube.com/watch?v=a4WGVOzTR4A',
      quizzes: [{
        id: 'tq4-1',
        question: '和宝宝多说话有助于语言发展吗?',
        options: ['有', '没有', '不确定']
      }, {
        id: 'tq4-2',
        question: '宝宝什么时候开始说第一个词?',
        options: ['6-9个月', '9-12个月', '12-18个月']
      }]
    }, {
      id: 'today-v5',
      title: '宝宝运动能力培养',
      duration: '6:15',
      url: 'https://www.youtube.com/watch?v=TW5gze4133s',
      quizzes: [{
        id: 'tq5-1',
        question: '爬行对宝宝发展重要吗?',
        options: ['重要', '不重要', '可有可无']
      }, {
        id: 'tq5-2',
        question: '应该让宝宝多趴着玩吗?',
        options: ['应该', '不应该', '看情况']
      }]
    }]
  };
  const toggleVideo = (videoId: string) => {
    setPlayingVideo(videoId);
  };
  const handleBackClick = () => {
    if (playingVideo) {
      setPlayingVideo(null);
    } else {
      navigate(-1);
    }
  };
  return <div className="flex flex-col min-h-screen bg-gradient-to-b from-purple-50 to-blue-50 pb-16" data-id="element-0">
      <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-1">
        <div className="px-4 py-3 flex items-center justify-center relative" data-id="element-2">
          <h1 className="text-2xl font-bold text-amber-700" data-id="element-3">Everseed</h1>
          <div className="flex items-center space-x-3 absolute right-4" data-id="element-4">
            <Link to="/notifications" className="relative" data-id="element-5">
              <BellIcon size={24} className="text-gray-600" data-id="element-6" />
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full font-bold" data-id="element-7">
                3
              </span>
            </Link>
            <img src={currentUser.avatar} alt={currentUser.name} className="w-9 h-9 rounded-full object-cover border-2 border-indigo-200" data-id="element-8" />
          </div>
        </div>
      </header>
      <main className="flex-1 px-4 py-4" data-id="element-9">
        <div className="mb-4" data-id="element-10">
          <h2 className="text-xl font-bold text-gray-800 mb-3" data-id="element-11">今日课程</h2>
          {todayCourse.videos.map((video, index) => {
          const isPlaying = playingVideo === video.id;
          const nextVideos = todayCourse.videos.slice(index + 1);
          if (isPlaying) {
            return <div key={video.id} className="mb-4" data-id="element-12">
                  <div className="bg-white rounded-2xl overflow-hidden shadow-lg mb-4" data-id="element-13">
                    <div className="relative aspect-video" data-id="element-14">
                      <ReactPlayer url={video.url} width="100%" height="100%" controls light playing={false} data-id="element-15" />
                    </div>
                    <div className="p-3" data-id="element-16">
                      <h4 className="font-semibold text-gray-800" data-id="element-17">
                        {video.title}
                      </h4>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-18">
                        {video.duration}
                      </p>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-sm mb-4" data-id="element-19">
                    <div className="flex items-center mb-3" data-id="element-20">
                      <HelpCircleIcon size={18} className="text-indigo-600 mr-2" data-id="element-21" />
                      <h5 className="text-sm font-semibold text-gray-700" data-id="element-22">
                        小测验
                      </h5>
                    </div>
                    <p className="text-xs text-gray-500 mb-3" data-id="element-23">
                      观看后将测试以下内容:
                    </p>
                    <div className="space-y-2" data-id="element-24">
                      {video.quizzes.map((quiz, idx) => <div key={quiz.id} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-25">
                          <span className="text-indigo-600 font-medium" data-id="element-26">
                            {idx + 1}.
                          </span>
                          <span data-id="element-27">{quiz.question}</span>
                        </div>)}
                    </div>
                  </div>
                  {nextVideos.length > 0 && <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-28">
                      <h5 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-29">
                        接下来的视频
                      </h5>
                      <div className="space-y-2" data-id="element-30">
                        {nextVideos.map((nextVideo, idx) => <div key={nextVideo.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 active:bg-gray-200 transition-colors" onClick={() => toggleVideo(nextVideo.id)} data-id="element-31">
                            <div className="flex items-center gap-3 flex-1" data-id="element-32">
                              <div className="w-6 h-6 rounded-full bg-amber-100 flex items-center justify-center text-amber-600 text-xs font-semibold" data-id="element-33">
                                {index + idx + 2}
                              </div>
                              <div className="flex-1" data-id="element-34">
                                <p className="text-sm font-medium text-gray-800" data-id="element-35">
                                  {nextVideo.title}
                                </p>
                                <p className="text-xs text-gray-500" data-id="element-36">
                                  {nextVideo.duration}
                                </p>
                              </div>
                            </div>
                            <PlayCircleIcon size={20} className="text-indigo-600" data-id="element-37" />
                          </div>)}
                      </div>
                    </div>}
                </div>;
          }
          if (index === 0 && !playingVideo) {
            return <div key={video.id} className="bg-white rounded-2xl overflow-hidden shadow-lg cursor-pointer" onClick={() => toggleVideo(video.id)} data-id="element-38">
                  <div className="relative aspect-video" data-id="element-39">
                    <ReactPlayer url={video.url} width="100%" height="100%" controls={false} light playing={false} data-id="element-40" />
                  </div>
                  <div className="p-3" data-id="element-41">
                    <h4 className="font-semibold text-gray-800" data-id="element-42">
                      {video.title}
                    </h4>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-43">
                      {video.duration}
                    </p>
                  </div>
                </div>;
          }
          return null;
        })}
        </div>
        <UserRank user={currentUser} data-id="element-44" />
        <div className="mt-8" data-id="element-45">
          <KidsPerformanceSection data-id="element-46" />
        </div>
      </main>
      <BottomNav onBackClick={handleBackClick} data-id="element-47" />
    </div>;
}